/**
 * Parse a single value, converting JSON strings to objects/arrays recursively.
 */
function parseValue(value: any): any {
  if (typeof value === 'string') {
    if (value.startsWith('{') || value.startsWith('[')) {
      try {
        const parsed = JSON.parse(value);
        // Recursively parse the result in case of nested JSON strings
        return parseValue(parsed);
      } catch {
        // Not valid JSON, keep as string
      }
    }
    return value;
  }
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    // Recursively parse nested objects (for inclusion/exclusion with stringified segment data)
    const parsed: Record<string, any> = {};
    for (const [k, v] of Object.entries(value)) {
      parsed[k] = parseValue(v);
    }
    return parsed;
  }
  return value;
}

/**
 * Parse stored operator parameters back to form data format.
 * Converts JSON strings to objects/arrays recursively.
 */
export function parseOperatorParameters(parameters: Record<string, any>): Record<string, any> {
  const data: Record<string, any> = {};
  for (const [key, value] of Object.entries(parameters)) {
    if (key === 'id') continue;
    data[key] = parseValue(value);
  }
  return data;
}
